import { PAYMENT_SOURCE_TYPE } from "constants/patients";
import { formatMoney } from "utils/common";

import { PATIENT_BALANCE_OPTIONS } from "../merge-tags-options/patient-balance-utils";
import { MergeTagsReplaceHandler } from "./merge-tags-values";

export const PATIENT_BALANCE_VALUES: MergeTagsReplaceHandler = {
  [PATIENT_BALANCE_OPTIONS.BALANCE_TOTAL]: ({ data }) => {
    return formatMoney(Number(data.patient?.totalBalance));
  },
  [PATIENT_BALANCE_OPTIONS.BALANCE_PAYMENT_SOURCE]: ({ data }) => {
    return PAYMENT_SOURCE_TYPE.getFromCode(data.patient?.paymentSourceType);
  },

  [PATIENT_BALANCE_OPTIONS.BALANCE_MANAGED_CARE_PLAN]: ({ data }) => {
    return data.patient?.managed_care_plan?.name;
  },

  [PATIENT_BALANCE_OPTIONS.BALANCE_MANAGED_CARE_RESPONSIBILITY]: ({ data }) => {
    return formatMoney(
      Number(data.patient?.managed_care_responsibility_balance)
    );
  },

  [PATIENT_BALANCE_OPTIONS.BALANCE_PATIENT_RESPONSIBILITY]: ({ data }) => {
    return formatMoney(Number(data.patient?.patient_responsibility_balance));
  },

  [PATIENT_BALANCE_OPTIONS.BALANCE_INSURER_RESPONSIBILITY]: ({ data }) => {
    return formatMoney(Number(data.patient?.insurer_responsibility_balance));
  },

  [PATIENT_BALANCE_OPTIONS.BALANCE_INSURANCE_POLICY]: ({ data }) => {
    return data.patient?.primary_insurance_policy?.insurer?.name;
  }
};
